import { HiddenFieldFragmentFragment } from '../../../../__generated__/graphql';
import Input from '../../../../components/Input';
import { useGravityFormsDispatch, useSelectHiddenFieldValue, useSelectInitialized } from '../../state/hooks';
import { useSetInitialValue } from '../hooks';

interface Props {
  field: HiddenFieldFragmentFragment;
}

const HiddenInput = ({ field }: Props) => {
  const {
    databaseId,
    label,
  } = field;

  const dispatch = useGravityFormsDispatch();

  const fieldValue = useSelectHiddenFieldValue(databaseId);
  const initialized = useSelectInitialized();

  useSetInitialValue({ field, fieldValue }, resolvedValue => {
    dispatch({
      payload: {
        id: databaseId,
        value: resolvedValue,
      },
      type: 'updateHiddenFieldValue',
    });
  });

  if (initialized && !fieldValue) {
    return null;
  }

  return (
    <Input
      defaultValue={fieldValue?.value ?? ''}
      id={databaseId.toString()}
      label={label ?? ''}
      type="hidden"
    />
  );
};

export default HiddenInput;
